import React from "react";
import { Spinner } from "react-bootstrap";

type ThemeSpinnerProps = { className?: string };

function ThemeSpinner({ className = "" }: ThemeSpinnerProps) {
  return <Spinner animation="border" role="status" className={`border-bottom-0 text-primary m-auto fs-7 ${className}`} />;
}

export default ThemeSpinner;
